import {
    CURRENCY_REQUEST,
    CURRENCY_SUCCESS,
    CURRENCY_FAIL
} from "../constants/AuthConstant";

const initialState = {
    result: [],
    loading: null,
    error: null
};

const CurrencyReducer = (state = initialState, action) => {
    switch (action.type) {
        case CURRENCY_REQUEST:
            return {
                ...state,
                loading: action.payload,
            };

        case CURRENCY_SUCCESS:
            return {
                ...state,
                result: action.result.data,
                loading: action.payload,
            };

        case CURRENCY_FAIL:
            return {
                ...state,
                error: action.error,
                loading: action.payload,
                msg: action.msg,
            };

        default:
            return state;
    }
};

export default CurrencyReducer;